import { FC } from 'react';

import cs from 'classnames';

import LocationDisplay from 'components/LocationDisplay/LocationDisplay';

import { Job } from 'types/jobs';

import styles from './OptionJobWithLocation.module.scss';

interface OptionJobWithLocationProps {
  job: Job;
  isSelectedOption?: boolean;
}

const OptionJobWithLocation: FC<OptionJobWithLocationProps> = ({
  job,
  isSelectedOption = false
}: OptionJobWithLocationProps) => {
  return (
    <div className={styles.container}>
      <div
        className={cs(styles.title, {
          [styles.titleSelected]: isSelectedOption
        })}
      >
        {job.title}
      </div>

      {isSelectedOption ? (
        <div className={styles.city}>
          {job.location?.city || job.country?.name}
        </div>
      ) : (
        <LocationDisplay
          countryCode={job.country?.code}
          location={job.location}
          className={cs(styles.location, {
            [styles.selected]: isSelectedOption
          })}
          isFlagAtEnd
        />
      )}
    </div>
  );
};

export default OptionJobWithLocation;
